import { clientConnector } from '@games/socket-client'
import { createStateHandler } from './processHandlers/state'

/**
 * Расширяет clientConnector для работы с игровыми событиями
 */
export function extendSocketWithGame(): void {
  const stateHandler = createStateHandler()
  // Регистрируем компонент для игровых событий
  const gameComponent = {
    name: 'game',
    methods: {
       // Mirror Action - метод для вызова действий в игровом ядре
      mirrorAction: {
        emitEvent: 'game:mirrorAction',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onMirrorActionResponse'
      },

      // Отправка системных действий (исправлено!):
      // было два метода с одинаковым именем "systemAction"
      sendSystemAction: {
        emitEvent: 'game:sendSystemAction',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onSystemActionResponse'
      },
      
      // Запрос текущего состояния игры
      getState: {
        emitEvent: 'game:getState',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onStateReceived'
      },
      
      // Установка победителя (для админов)
      setWinnerDebug: {
        emitEvent: 'game:setWinnerDebug',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onWinnerSet'
      },
      
      // Сдача игрока
      surrender: {
        emitEvent: 'game:surrender',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onSurrenderProcessed'
      },

      endTurn: {
        emitEvent: 'game:endTurn',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onEndTurnProcessed'
      },

      // Завершение хода виртуального игрока PC (pve2).
      // Может вызвать любой из двух человек, когда PC завершил свою логику на клиенте.
      endPcTurn: {
        emitEvent: 'game:endPcTurn',
        expectsResponse: true,
        timeout: 5000,
        responseMethodName: 'onEndPcTurnProcessed'
      },
  
      // События, которые приходят от сервера
      onGameStateChanged: {
        listenEvent: 'game:onGameStateChanged',
        processHandler: stateHandler, 
        responseMethodName: 'onGameStateChanged'
      },
    }
  }
  
  // Регистрируем компонент
  clientConnector.registerComponent(gameComponent);
}
